import { motion } from "framer-motion";
import { MANIFESTO } from "../../lib/site";

export const Manifesto = () => {
  return (
    <section id="ethos" className="relative py-24 md:py-36 bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <p className="text-xs uppercase tracking-[0.3em] text-[#C9A24B] mb-16">Our Ethos</p>

        <div className="space-y-16 md:space-y-24">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.no}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start border-t border-white/10 pt-10"
              data-testid={`manifesto-${m.no}`}
            >
              <div className="md:col-span-3 font-serif-display text-6xl md:text-8xl font-light text-stroke-gold leading-none">
                {m.no}
              </div>
              <h3 className="md:col-span-4 font-serif-display text-3xl md:text-5xl font-light tracking-tight text-[#FAFAFA]">
                {m.title}
              </h3>
              <p className="md:col-span-5 text-base text-[#8A8A8A] font-light leading-relaxed">
                {m.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
